import React, { useState } from "react";
import MobileLayout from "../MobileLayout";
import MobileNewContactsList from "./MobileNewContactsList";
import MobileSubmissionDrawer from "./MobileSubmissionDrawer";

export default function MobileNewContactsPage() {
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleOpenSubmission = (submission) => {
    setSelectedSubmission(submission);
  };

  const handleCloseDrawer = () => {
    setSelectedSubmission(null);
  };

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <MobileLayout title="New Contacts">
      <MobileNewContactsList 
        key={refreshKey} 
        onOpenSubmission={handleOpenSubmission} 
      />
      <MobileSubmissionDrawer
        open={Boolean(selectedSubmission)}
        submission={selectedSubmission}
        onClose={handleCloseDrawer}
        onRefresh={handleRefresh}
      />
    </MobileLayout>
  );
}
